var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import MapboxDraw from "@mapbox/mapbox-gl-draw";
import RectangleMode from "mapbox-gl-draw-rectangle-mode";
import styles from "../styled/draw-styles";
export var defaultMode = "simple_select";
export var drawOptions = {
  styles: styles,
  clickBuffer: 10,
  displayControlsDefault: false,
  modes: __assign(__assign({}, MapboxDraw.modes), {
    rectangle: RectangleMode
  }),
  controls: {
    // White-listing the trash control gives us Backspace/Delete
    // keyDown functionality to remove drawn shapes.
    // We are hiding the corresponding draw controls
    // via css in the map/Container component.
    trash: true
  }
};